import type { FC } from 'react';

import { HelpCaption } from '../captions/help-caption';
import { HelpCaptionDescription } from '../captions/help-caption-description';
import { SupportTitle } from '../captions/support-title';
import { WistiaPlayer } from '../player/wistia-player';

const PLAYER_HEIGHT = '533px';
// cspell:ignore gsdt43asbp
const MEDIA_ID = 'gsdt43asbp';

export const ShipmentTrackingCarrierHelpCenterContent: FC = () => {
  return (
    <div className="d-flex flex-direction-column">
      <SupportTitle />
      <HelpCaption>Transportation Provider Shipment Status Updating</HelpCaption>
      <HelpCaptionDescription>
        The purpose of this feature is to enable carriers to seamlessly update the shipment tracking status in real-time
        as the shipment moves through various transit stages. This functionality ensures that all stakeholders,
        including shippers and recipients, receive accurate and timely information regarding the current location and
        status of their shipments, thereby enhancing transparency and improving overall customer satisfaction.
      </HelpCaptionDescription>
      <WistiaPlayer mediaId={MEDIA_ID} height={PLAYER_HEIGHT} />
    </div>
  );
};
